import './index.css'

const TabItem = props => {
  const {isActive, clickFun, data} = props
  const {displayText, tabId} = data
  const onclickTabs = () => {
    clickFun(tabId)
  }
  let clsname
  if (isActive) {
    clsname = 'activeTab'
  } else {
    clsname = ''
  }
  return (
    <li>
      <button className={clsname} onClick={onclickTabs} type="button">
        {displayText}
      </button>
    </li>
  )
}
export default TabItem
